"use strict";
var AxiosError = require("../core/AxiosError");
var utils = require("../utils");
function CanceledError(message) {
  AxiosError.call(this, message == null ? "canceled" : message, AxiosError.ERR_CANCELED);
  this.name = "CanceledError";
}
utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});
module.exports = CanceledError;
